var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 0C26.88 0 0 26.88 0 60C0 93.12 26.88 120 60 120C93.12 120 120 93.12 120 60C120 26.88 93.12 0 60 0ZM60 18C69.96 18 78 26.04 78 36C78 45.96 69.96 54 60 54C50.04 54 42 45.96 42 36C42 26.04 50.04 18 60 18ZM60 103.2C45 103.2 31.74 95.52 24 83.88C24.18 71.94 48 65.4 60 65.4C71.94 65.4 95.82 71.94 96 83.88C88.26 95.52 75 103.2 60 103.2Z",
    fill: "#ff1200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileRed);
export default __webpack_public_path__ + "static/media/ProfileRed.9e85e56a3be89eb411f6e4e930e4c78e.svg";
export { ForwardRef as ReactComponent };